enum TipoMembroComissaoEnum {
  PRESIDENTE = 1,
  MEMBRO = 2,
  MESARIO = 3,
}

export default TipoMembroComissaoEnum;
